import $ from 'jquery'
import {Core} from "./core.js";

export class MenuPrimary {

  constructor() {
    this.$container = $('header.header nav.header-primary')

    if (this.$container === undefined) {
      return
    }

    this.classes = {
      'submenu': 'has-submenu',
      'submenuItems': 'submenu',
      'itemSubmenu': 'item-submenu',
      'burgerButton': 'burger-button',
      'submenuProduct': 'submenu-product',
      'submenuContent': 'submenu-content',
      'dataSubmenuLink': 'data-submenu-link',
      'dataSubmenuContent': 'data-submenu-content',
      'itemTitle': 'item-title',
      'linkReturn': 'link-return',
      'overlay': 'header-overlay',
      'active': 'active'
    }
    this.bpHeader = 768
    this.bpHeaderDesktop = 1279
    this.$window = $(window)
    this.$html = $('html')
    this.$body = $('body')
    this.$header = $('header.header')
    this.$submenu = this.$container.find(`.${this.classes.submenu} > .link`)
    this.$subItems = this.$container.find(`.${this.classes.submenuProduct} .submenu-product-left > ul > li:not(.submenu-product-all-link) > .link`)
    this.$itemTitle = this.$header.find(`.${this.classes.itemTitle} > .link`)
    this.$burgerButton = this.$header.find(`.${this.classes.burgerButton}`)
    this.$linkReturnBack = this.$header.find(`.${this.classes.linkReturn} button.return`)
    this.$linkReturnClose = this.$header.find(`.${this.classes.linkReturn} button.close`)
    this.$titleLink = this.$container.find('li.links > .title-link, li.links > .title-no-link')
    this.$overlay = this.$header.find(`.${this.classes.overlay}`)
    this.previousScroll = 0

    this.$submenu.on('click', this.handlerClickSubmenu.bind(this))
    this.$subItems.on('click', this.handlerClickSubmenuItems.bind(this))
    this.$itemTitle.on('click', this.handlerClickItemTitle.bind(this))
    this.$burgerButton.on('click', this.handlerClickMenuBurger.bind(this))
    this.$linkReturnBack.on('click', this.handlerClickLinkReturn.bind(this))
    this.$linkReturnClose.on('click', this.handlerClickLinkClose.bind(this))
    this.$titleLink.on('click', this.handlerClickTitleLink.bind(this))
    this.$overlay.on('click', this.handlerClickHeaderOverlay.bind(this))

    this.$window.on('resize', this.handleResize.bind(this))
    this.$window.on('scroll', this.handleScroll.bind(this))

    this.syncTitleLinksA11y()
  }

  isDesktop() {
    return this.$window.width() >= this.bpHeaderDesktop
  }

  syncTitleLinksA11y() {
    let desktop = this.isDesktop()
    this.$titleLink.each((_, el) => {
      let $btn = $(el)
      if (desktop) {
        $btn.removeAttr('aria-expanded').removeAttr('aria-controls')
      } else {
        let panelId = $btn.siblings('.submenu-content').attr('id')
        if (panelId) {
          $btn.attr('aria-controls', panelId)
        }
        if (!$btn.attr('aria-expanded')) {
          $btn.attr('aria-expanded', 'false')
        }
      }
    })
  }

  handleScroll(e) {
    let currentScroll = this.$window.scrollTop()
    let threshold = this.getMenusHeight()
    let hasBigSubmenu = $('section.big-submenu').length

    if (currentScroll <= threshold && !hasBigSubmenu) {
      // Encore dans la zone des deux menus -> toujours visibles
      this.$body.removeClass('header-hidden')
    } else if (currentScroll < this.previousScroll) {
      // Scroll up -> afficher
      this.$body.removeClass('header-hidden')
    } else {
      // Scroll down au-delà du seuil -> masquer
      this.$body.addClass('header-hidden')
    }

    this.previousScroll = currentScroll
  }

  getMenusHeight() {
    let height = this.$header.outerHeight() || 0
    let $navTop = $('.nav-top')

    // En mobile le nav-top passe en position static (dans le burger) -> exclu du seuil
    if ($navTop.length && $navTop.css('position') === 'fixed') {
      height += $navTop.outerHeight()
    }

    return height
  }

  handlerClickSubmenu(e) {
    e.preventDefault()
    const $submenu = $(e.currentTarget).parent()

    if ($submenu.find(`.${this.classes.submenuProduct}`).length && $(window).width() < this.bpHeaderDesktop) {
      $submenu.find(`.${this.classes.active}`).removeClass(this.classes.active)
    }

    if ($submenu.hasClass(this.classes.active)) {
      $submenu.parent().find(`.${this.classes.submenu}.${this.classes.active}`).removeClass(this.classes.active)
      this.$header.removeClass(this.classes.active)
      Core.activeBodyScroll()
    } else {
      $submenu.parent().find(`.${this.classes.submenu}.${this.classes.active}`).removeClass(this.classes.active)
      $submenu.addClass(this.classes.active)
      this.$header.addClass(this.classes.active)
      Core.disableBodyScroll()
    }
  }

  handlerClickHeaderOverlay(e) {
    this.resetTitleLinks()
    this.$header.find(`.${this.classes.active}`).removeClass(this.classes.active)
    Core.activeBodyScroll()
    this.closeBurgerMenu()
  }

  handlerClickSubmenuItems(e) {
    e.preventDefault()
    let $item = $(e.currentTarget)
    let $itemParent = $item.parent()

    $itemParent.closest('ul').find(`.${this.classes.active}`).removeClass(this.classes.active)
    $itemParent.addClass(this.classes.active)

    let dataSubmenuLink = $item.attr(this.classes.dataSubmenuLink)

    if (dataSubmenuLink) {
      let $submenu = $item.closest(`.${this.classes.submenuProduct}`)

      $submenu.find(`.${this.classes.active}[${this.classes.dataSubmenuContent}]`).removeClass(this.classes.active)
      $submenu.find(`[${this.classes.dataSubmenuContent}=${dataSubmenuLink}]`).addClass(this.classes.active)
    }
  }

  handlerClickMenuBurger(e) {
    e.preventDefault()

    if (this.$header.hasClass(this.classes.active)) {
      this.closeBurgerMenu()
    } else {
      this.openBurgerMenu()
    }
  }

  openBurgerMenu() {
    this.$header.addClass(this.classes.active)
    this.$body.addClass('menu-primary-open')
    this.$burgerButton.attr('aria-expanded', 'true')
  }

  closeBurgerMenu() {
    this.$header.removeClass(this.classes.active)
    this.$body.removeClass('menu-primary-open')
    this.$burgerButton.attr('aria-expanded', 'false')
  }

  handlerClickLinkReturn(e) {
    e.preventDefault()
    let $linkReturn = $(e.currentTarget)
    let $active = $linkReturn.closest(`.${this.classes.active}`)
    let panelId = $active.attr('id')
    if (panelId) {
      this.$container.find(`button[aria-controls="${panelId}"]`).attr('aria-expanded', 'false')
    }
    $active.removeClass(this.classes.active)
  }

  handlerClickLinkClose(e) {
    e.preventDefault()
    this.resetTitleLinks()
    this.$header.find(`.${this.classes.active}`).removeClass(this.classes.active)
    this.closeBurgerMenu()
  }

  handlerClickTitleLink(e) {
    if (this.isDesktop()) return

    e.preventDefault()

    let $button = $(e.currentTarget)
    let $panel = $button.siblings('.submenu-content').first()

    if (!$panel.length) return

    $panel.addClass(this.classes.active)
    $button.attr('aria-expanded', 'true')
  }

  resetTitleLinks() {
    this.$container.find('button.title-link[aria-expanded="true"]').attr('aria-expanded', 'false')
  }

  handlerClickItemTitle(e) {
    e.preventDefault()
    let $item = $(e.currentTarget)
    let dataSubmenuLink = $item.attr(this.classes.dataSubmenuLink)

    if (dataSubmenuLink) {
      $item.closest(`.${this.classes.submenuProduct}`).find(`[${this.classes.dataSubmenuContent}=${dataSubmenuLink}]`).addClass(this.classes.active)
    } else {
      $item.parent().find(`.${this.classes.itemSubmenu}`).addClass(this.classes.active)
    }
  }

  handleResize(e) {
    this.resetTitleLinks()
    this.$header.find(`.${this.classes.active}`).removeClass(this.classes.active)
    this.closeBurgerMenu()
    this.syncTitleLinksA11y()
  }
}
